const getFirstName = (fullName?: string) => {
  if (!fullName) {
    return 'Learner';
  }
  return fullName.includes(' ') ? fullName.split(' ')[0] : fullName;
};

export default getFirstName;
